module.exports = __webpack_public_path__ + "static/media/Aleo-Light.dc80a852.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Aleo-Light.eot
// module id = 2910
// module chunks = 68